import React from 'react';
import PropTypes from 'prop-types';

export default function TableHeader({ setColumnOrder, columnOrder }) {
    return (
        <>
            <tr className='table-head'>
                <th className="text-center" style={{minWidth: '120px'}}>
                    Código<br />
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="c_provider_id"
                    />
                </th>
                <th className="text-center" style={{minWidth: '120px'}}>
                    Proveedor<br />
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="c_provider_id"
                    />
                </th>
                <th className="text-center" style={{minWidth: '100px'}}>
                    Fecha<br />
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="mov_date"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Producto
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Unidad de Medida
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Entradas<br />
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="pieces"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Salidas<br />
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="pieces_client"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Existencias
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="bal_pieces"
                    />                    
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Unidad
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Entradas<br />
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="kgs"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Salidas<br />
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="kgs_client"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Existencias<br />
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="bal_kgs"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Precio Costo
                    <ArrowsOrder 
                        setColumnOrder={ setColumnOrder }
                        columnOrder={ columnOrder }
                        column="cost"
                    />
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Valuación
                </th>
                <th className="text-center" style={{minWidth: '80px'}}>
                    Observaciones
                </th>
            </tr>
        </>
    );
}

TableHeader.propTypes = {
    setColumnOrder: PropTypes.func,
    columnOrder: PropTypes.object
};

const ArrowsOrder = ({ setColumnOrder, column, columnOrder }) => {
    
    const isArrowDownActive = (columnOrder.column === column && columnOrder.order === 'desc');
    const isArrowUpActive = (columnOrder.column === column && columnOrder.order === 'asc');

    return (
        <span className="order arrows-order">
            <span 
                onClick={() => setColumnOrder({
                    column,
                    order: 'desc'
                })}
                className={`dropdown arrows-order__asc ${ isArrowDownActive && 'active'}`}
            >
                <span className="caret"></span>
            </span>
            <span 
                onClick={() => setColumnOrder({
                    column,
                    order: 'asc'
                })}
                className={`dropup arrows-order__desc ${isArrowUpActive && 'active'}`}
            >
                <span className="caret"></span>
            </span>
        </span>
    )
}

ArrowsOrder.propTypes = {
    column: PropTypes.string,
    setColumnOrder: PropTypes.func,
    columnOrder: PropTypes.object
};